// Client-side upload size validation.
//
// The server (multer) rejects files above this size. Validating here lets us show a
// clear message *before* uploading, instead of the opaque network error the browser
// gets when the request is rejected mid-upload. Traefik imposes no body-size limit.

const MAX_UPLOAD_SIZE_MB = 1024;
const MAX_UPLOAD_SIZE_BYTES = MAX_UPLOAD_SIZE_MB * 1024 * 1024;

const toMb = (bytes) => Math.round(bytes / (1024 * 1024));

/**
 * Validate a list of files against the maximum upload size.
 * @param {Array<{name: string, size: number}>} files
 * @returns {{ valid: boolean, error: string|null }}
 */
function validateFiles(files) {
    const list = Array.isArray(files) ? files : [];

    for (const file of list) {
        if (file && typeof file.size === 'number' && file.size > MAX_UPLOAD_SIZE_BYTES) {
            return {
                valid: false,
                error: `Le fichier « ${file.name} » est trop volumineux (${toMb(file.size)} Mo). `
                    + `Taille maximale autorisée : ${MAX_UPLOAD_SIZE_MB} Mo.`,
            };
        }
    }

    return { valid: true, error: null };
}

module.exports = { validateFiles, MAX_UPLOAD_SIZE_BYTES, MAX_UPLOAD_SIZE_MB };
